import { createSelector } from "reselect";
import { getSelectedCoin } from "../contests/selectors";
import _ from "lodash";

export const getAllPositions = createSelector(
  (state) => state.positions,
  (positions) => {
    if (!positions) {
      return positions;
    }
    // Position Manager tickets/entries should be sorted as follows:
    // 1) by expiration date (soonest to furthest)
    // 2) then by Ticket Type (alphabetically); example: (BTC TIX, then BTC WIX, then ETH TIX, etc.)
    // 3) then by strike price (ascending)
    return [...positions].sort((p1, p2) => {
      const exp = +p1.expiration - p2.expiration;
      if (exp !== 0) {
        return exp;
      }

      const index = `${p1.index} ${p1.market_type}`.localeCompare(
        `${p2.index} ${p2.market_type}`
      );
      if (index !== 0) {
        return index;
      }

      const strike1 =
        p1.direction?.toLowerCase() === "below"
          ? -1 * p1.strike
          : 1 * p1.strike;
      const strike2 =
        p2.direction?.toLowerCase() === "below"
          ? -1 * p2.strike
          : 1 * p2.strike;
      return strike1 - strike2;
    });
  }
);

export const selectTixWixWallet = (state) => {
  const { balance, availableBalance, totalUsd, isGetWallet } = state.tixwix;
  return { balance, availableBalance, totalUsd, isGetWallet };
};

export const getCurrentIndex = (state) => state.tixwix.tixIndex;
export const getCurrentDate = (state) => state.tixwix.tixDate;
export const selectMarketType = (state) => state.tixwix.marketType;
export const selectTixwixDate = (state) => state.tixwix.date;

export const selectTixwixTrading = (state) => state.tixwix.trading;
export const selectTixwixMarkets = (state) => state.tixwix.marketsTixWix;
export const selectMarketsExpirate = (state) => state.tixwix.marketsExpirate;
export const selectTixwixPriceGoing = (state) => state.tixwix.priceGoing;

export const marketCoinList = createSelector(
  selectTixwixMarkets,
  ({ markets }) => {
    const coins = new Set();
    Object.values(markets).forEach(({ Product }: any) => {
      const [coin] = Product.split("/");
      coins.add(coin);
    });
    return Array.from(coins);
  }
);

export const getFilterViewData = createSelector(
  selectTixwixDate,
  selectMarketType,
  selectTixwixMarkets,
  selectMarketsExpirate,
  getSelectedCoin,
  (date, marketType, marketsTixWix, marketsExpirate, coin) => {
    const dataFilterViewDraft = (marketsTixWix.filtermarkets[date] || []).map(
      (id) => {
        if (!marketsExpirate.includes(id)) {
          return marketsTixWix.markets[id];
        } else return;
      }
    );
    const dataFilterView = dataFilterViewDraft.filter(
      (data) =>
        data &&
        data.Type === marketType &&
        data.Product &&
        data.Product.indexOf(coin) > -1
    );
    return dataFilterView.sort((a, b) => {
      return b.Strike - a.Strike;
    });
  }
);

export const getHotViewData = createSelector(
  selectMarketType,
  selectTixwixMarkets,
  selectMarketsExpirate,
  getSelectedCoin,
  (marketType, marketsTixWix, marketsExpirate, coin) => {
    const dataHotViewDraft = (marketsTixWix.hotmarkets || []).map((id) => {
      if (!marketsExpirate.includes(id)) {
        return marketsTixWix.markets[id];
      } else return;
    });
    const dataHotView = dataHotViewDraft.filter(
      (data) =>
        data &&
        data.Type === marketType &&
        data.Product &&
        data.Product.indexOf(coin) > -1
    );
    return dataHotView.sort((a, b) => {
      return b.Strike - a.Strike;
    });
  }
);

export const getScrollDate = createSelector(
  getSelectedCoin,
  selectTixwixMarkets,
  (coin, marketsTixWix) => {
    const dateList = Object.values(marketsTixWix.markets || {}).filter(
      (market: any) =>
        market?.Product &&
        market?.YesOdds &&
        market.NoOdds &&
        market.Product.indexOf(coin) > -1
    );
    const dates = _(dateList)
      .groupBy("Expiry")
      .mapValues((m) => _.map(m, "Id"))
      .value();
    return dates;
  }
);
